export const LOCAL_AUDIO_BRIDGE_EVENT = 'museflow-local-audio-bridge-event';
export const LOCAL_AUDIO_GRADE_EVENT = 'museflow-local-audio-grade-event';

export type LocalAudioBridgeEventDetail = {
  capturedAtMs: number;
  observedAtMs?: number | null;
  audioTimeMs: number | null;
  type: 'note-on' | 'note-off';
  midiNote: number;
  reason: 'recognized' | 'rearticulation' | 'release' | 'flush';
};

export type LocalAudioGradeEventDetail = {
  capturedAtMs: number;
  eventId?: string;
  midiNote: number;
  playedMidiNote: number | null;
  phase: 'onset' | 'offset';
  scoreTimestamp: number;
  expectedOffsetTimestamp?: number;
  noteLength?: number;
  hand?: string;
  playedTimestamp: number | null;
  state: string;
};

const canEmitLocalDiagnostics = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
};

export const emitLocalAudioBridgeEvent = (
  detail: Omit<LocalAudioBridgeEventDetail, 'capturedAtMs'>,
) => {
  if (!canEmitLocalDiagnostics()) return;
  window.dispatchEvent(
    new CustomEvent<LocalAudioBridgeEventDetail>(LOCAL_AUDIO_BRIDGE_EVENT, {
      detail: { ...detail, capturedAtMs: Date.now() },
    }),
  );
};

export const emitLocalAudioGradeEvent = (
  detail: Omit<LocalAudioGradeEventDetail, 'capturedAtMs'>,
) => {
  if (!canEmitLocalDiagnostics()) return;
  window.dispatchEvent(
    new CustomEvent<LocalAudioGradeEventDetail>(LOCAL_AUDIO_GRADE_EVENT, {
      detail: { ...detail, capturedAtMs: Date.now() },
    }),
  );
};
